import styled from 'styled-components';

import { GridItem } from '@xing-com/grid';
import {
  SkeletonHeadline,
  SkeletonButton,
  SkeletonBody,
} from '@xing-com/skeleton';
import { scale000, scale250, spaceS } from '@xing-com/tokens';

const StyledGridItem = styled(GridItem)`
  display: flex;
  align-items: center;
`;

const StyledSkeletonHeadline = styled(SkeletonHeadline)`
  width: 100%;
  & > div {
    margin-bottom: ${scale000};
  }
`;

const StyledSkeletonButton = styled(SkeletonButton)`
  width: ${scale250};
  margin-left: auto;
`;

const StyledSkeletonBody = styled(SkeletonBody)`
  margin: ${scale000} ${scale000} ${spaceS};
`;

export const Styled = {
  GridItem: StyledGridItem,
  SkeletonHeadline: StyledSkeletonHeadline,
  SkeletonButton: StyledSkeletonButton,
  SkeletonBody: StyledSkeletonBody,
};
